import * as React from "react";

export const useTabs = (defaultTab = 1) => {
  const [currentTab, setCurrentTab] = React.useState<string | number>(
    defaultTab
  );

  const prev = React.useCallback(() => {
    setCurrentTab((curr) =>
      typeof curr === "number" ? (curr > 0 ? curr - 1 : curr) : curr
    );
  }, []);

  const next = React.useCallback(() => {
    setCurrentTab((curr) => (typeof curr === "number" ? curr + 1 : curr));
  }, []);

  const move = React.useCallback(
    (moveTabId: React.SetStateAction<string | number>) => {
      setCurrentTab(moveTabId);
    },
    []
  );

  return { prev, next, move, currentTab };
};

interface Props {
  children: React.ReactElement[] | React.ReactElement;
  currentTab: number | string;
  propsKey?: string;
}

const Tabs = React.memo<Props>(({ children, currentTab, propsKey }) => {
  return (
    <div className="tabs">
      {React.Children.toArray(children).filter((item, idx) => {
        const currentTabProps = (item as React.ReactElement).props as Record<
          string,
          unknown
        >;

        if (propsKey) {
          if (!currentTabProps[propsKey]) {
            console.error("Component에 props가 없거나, propsKey가 없습니다.");
            return null;
          }
          return currentTabProps[propsKey] === currentTab;
        }

        return idx + 1 === currentTab;
      })}
    </div>
  );
});

Tabs.displayName = "Tabs";
export default Tabs;
